import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import PaperLineIcon from '@icons/PaperLineIcon';
import RefreshLineIcon from '@icons/RefreshLineIcon';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        CardManageBottomSheet: {
            prepaidCardId: string;
            cardName: string;
        };
    }
}

/** 내 선불카드 관리(이름 변경, 사용 내역) */
const CardManageBottomSheet: ActivityComponentType<'CardManageBottomSheet'> = ({ params }) => {
    const { prepaidCardId, cardName } = params;
    const { t } = useTranslation('prepaidCard');
    const { pop, replace } = useFlow();

    const handleRename = () => {
        replace('UpdateCardNameBottomSheet', { prepaidCardId, cardName });
    };

    const handleHistory = () => {
        replace('PrepaidCardLogActivity', { prepaidCardId });
    };

    return (
        <BottomSheet>
            <Header>
                <Text size='title' fontWeight='bold'>
                    {t('manageSheet.title')}
                </Text>
            </Header>
            <Menus fullWidth spacing={2}>
                <Button variant='outlined'
                    size='medium'
                    fullWidth
                    onClick={handleRename}>
                    <RefreshLineIcon color={colors.textSecondary} />
                    <MenuText size='body-short' fontWeight='bold' color={colors.textSecondary}>
                        {t('manageSheet.rename')}
                    </MenuText>
                </Button>
                <Button variant='outlined'
                    size='medium'
                    fullWidth
                    onClick={handleHistory}>
                    <PaperLineIcon color={colors.textSecondary} />
                    <MenuText size='body-short' fontWeight='bold' color={colors.textSecondary}>
                        {t('manageSheet.history')}
                    </MenuText>
                </Button>
            </Menus>
            <Footer>
                <Button fullWidth onClick={pop}>
                    {t('manageSheet.close')}
                </Button>
            </Footer>
        </BottomSheet>
    );
};

const Header = styled.div`
    align-items: center;
    display: flex;
    height: 64px;
    justify-content: center;
`;

const Menus = styled(Column)`
    padding: 0 var(--spacing-4) var(--spacing-4);
`;

const MenuText = styled(Text)`
    margin-left: var(--spacing-2);
`;

const Footer = styled.div`
    padding: var(--spacing-4) var(--spacing-4) calc(var(--spacing-4) + var(--safe-area-bottom));
`;

export default CardManageBottomSheet;
